import { groupByCategory } from "@/utils/templateGroups";

interface TemplatePickerEntry {
  id: string;
  name: string;
  category?: string;
  sectionCount: number;
}

interface TemplatePickerProps {
  title: string;
  templates: TemplatePickerEntry[];
  onSelect: (templateId: string) => void;
  onClose: () => void;
}

function TemplateGroupList({
  onSelect,
  templates,
}: Readonly<{ templates: TemplatePickerEntry[]; onSelect: (id: string) => void }>) {
  const groups = groupByCategory(templates);
  return (
    <div className="template-groups">
      {groups.map((group) => (
        <section key={group.label} className="template-group">
          <h3 className="template-group-label">{group.label}</h3>
          <ul className="template-cards">
            {group.items.map((t) => (
              <li
                key={t.id}
                className="template-card"
                onClick={() => {
                  onSelect(t.id);
                }}
              >
                <span className="template-card-name">{t.name}</span>
                <span className="template-card-right">
                  <span className="field-count">{t.sectionCount} sections</span>
                </span>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}

export function TemplatePicker({
  onClose,
  onSelect,
  templates,
  title,
}: Readonly<TemplatePickerProps>) {
  return (
    <div className="report-preview-overlay" onClick={onClose}>
      <div
        className="report-preview-modal"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="report-preview-header">
          <span>{title}</span>
          <button onClick={onClose}>Close</button>
        </div>
        <div style={{ flex: 1, overflowY: "auto", padding: "16px" }}>
          {templates.length === 0 ? (
            <div className="placeholder">No templates available</div>
          ) : (
            <TemplateGroupList templates={templates} onSelect={onSelect} />
          )}
        </div>
      </div>
    </div>
  );
}
